import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">404</h1>
        <p className="auth-subtitle">Página não encontrada</p>
        <p style={{ textAlign: 'center', color: '#777', marginBottom: '2rem' }}>
          A página que você está procurando não existe.
        </p>
        <Link to="/login" className="btn btn-primary" style={{ width: '100%', textAlign: 'center' }}>
          Ir para Login
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
